import { render, staticRenderFns } from "./ListadoInscripciones.vue?vue&type=template&id=b552c5dc"
import script from "./ListadoInscripciones.vue?vue&type=script&lang=js"
export * from "./ListadoInscripciones.vue?vue&type=script&lang=js"
import style0 from "./ListadoInscripciones.vue?vue&type=style&index=0&id=b552c5dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports